module.exports = __webpack_public_path__ + "static/media/KE.59c85423.svg";